import $ from 'jquery';
import slick from 'slick-carousel';

const updateArrowState = ($slider, slick) => {
  const $prev = $slider.find('.slick-prev');
  const $next = $slider.find('.slick-next');

  const isFirst = slick.currentSlide === 0;
  const isLast =
    slick.currentSlide >= slick.slideCount - slick.options.slidesToShow;

  $prev.prop('disabled', isFirst);
  $next.prop('disabled', isLast);
};

const clearActiveSlideTabIndexes = ($slider) => {
  $slider.find('.slick-active a').removeAttr('tabindex');
};

var clearActiveSlideTabIndexesAfterSlick = (slider) => {
  setTimeout(function () {
    clearActiveSlideTabIndexes(slider);
  }, 0);
};

const partnersCarousel = () => {
  const $slider = $('.js-partnersCarousel');

  $slider.on('init', function (event, slick) {
    updateArrowState($(this), slick);
    clearActiveSlideTabIndexesAfterSlick($(this));
  });

  $slider.on('afterChange', function (event, slick) {
    updateArrowState($(this), slick);
    clearActiveSlideTabIndexesAfterSlick($(this));
  });

  $slider.slick({
    arrows: true,
    dots: false,
    slidesToShow: 6,
    slidesToScroll: 6,
    infinite: false,
    responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 4,
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
  ]
  });

}

export default partnersCarousel;
